import React from 'react';
import ReactTable from "react-table";
import treeTableHOC from "react-table/lib/hoc/treeTable";
import {
	Card,
	CardBody,
	CardTitle,
	Button, Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Input,Row, Col,
    ButtonGroup,
} from 'reactstrap';
import "react-table/react-table.css";
import * as data from "../tables/reactable-data";
import {auth} from "../../Api";
import Switch from "react-switch";
import { ReactSearchAutocomplete } from 'react-search-autocomplete'
import './company-view.scss'
import avatar from '../../assets/images/users/3.jpg'
import time4 from '../../assets/images/big/img4.jpg';
import { baseURL,baseImgURL } from '../../Api/BaseApi';
import { formatPhone } from '../../utils/phone'
import { termsAcceptanceText } from '../../utils/signup'
import { deleteSucceeded, deleteFailedMessage, DELETE_UNREACHABLE } from '../../utils/deleteReply'
import { formatServerMessage } from '../../utils/serverErrors'
import { rememberAccount, accountTypeLabel, PRIVATE } from '../../utils/accountType'

const { getCode, getName } = require('country-list');
const TreeTable = treeTableHOC(ReactTable);

class CompanyView extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			checked:false,
			open: false,
			modal: false,
			alertModal: false,
			obj: {},
			jsonData: data.dataTable,
			locationData: [],
			data: data.makeData(),
			treedata: data.treedata,
			avatarUrl:'/storage/avatar.jpg',
			companyData: [{
				"name":"Trial Company",
				"phonenumber":"+44123456789",
				"email":"trial@trial.com",
				"active":"True",
				"countrycode":"GB",
				"avatar":'/storage/avatar.jpg',
			}],
			companyId:null
		};
		this.toggle = this.toggle.bind(this);
		this.alertToggle = this.alertToggle.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}
	
	componentDidMount(){
		this.load()
	}

	load(){
		let companyId = localStorage.getItem('companyId')
		this.setState({companyId:companyId})
		var req={}
		req.id = companyId
		auth.getCompany(req)
			.then((res)=>{
				if(res.data.code==200){
					const reseller = res.data.message.reseller || null
					this.setState({
						companyData:res.data.message.users,
						avatarUrl: res.data.message.users[0].avatar,
						locationData:res.data.message.locations,
						// The super admin only: the Terms and Conditions the company accepted, and its free trial
						termsAcceptance: res.data.message.terms_acceptance,
						showsTerms: res.data.message.terms_acceptance !== undefined,
						trial: res.data.message.trial || null,
						// Company or Private (utils/accountType.js)
						account: res.data.message.account || null,
						// The super admin's Reseller choice (a Private account's too)
						reseller: reseller,
						resellerChoice: reseller && reseller.reseller_id ? String(reseller.reseller_id) : '0',
						resellerMessage: null
					})
					localStorage.setItem('companyInfo',JSON.stringify(res.data.message.users[0]))
					if (res.data.message.account) {
						rememberAccount(res.data.message.account)
					}
				}
			});
	}

	// The super admin: the company's reseller, or None (Mobiliis); recorded on the server (company_reseller_changes)
	saveReseller = () => {
		this.setState({ resellerBusy: true, resellerMessage: null })
		auth.setCompanyReseller({ id: this.state.companyId, admin_id: this.state.resellerChoice })
			.then((res) => {
				if (res.data.code == 200) {
					const reseller = res.data.reseller || this.state.reseller
					this.setState({ resellerBusy: false, reseller: reseller, resellerMessage: { ok: true, text: 'Saved.' } })
				} else {
					this.setState({ resellerBusy: false, resellerMessage: { ok: false, text: formatServerMessage(res.data.message, 'It could not be saved.') } })
				}
			})
			.catch(() => this.setState({ resellerBusy: false, resellerMessage: { ok: false, text: 'It could not be saved. Please try again.' } }))
	}

	// The super admin: a Private account becomes a Company one, or a Company one (with nothing a private account cannot
	// have) a Private one again
	makeCompany = () => {
		const toPrivate = this.state.switchModal === 'private'
		this.setState({ switchModal: false, switchMessage: null })
		;(toPrivate ? auth.makePrivateAccount : auth.makeCompanyAccount)({ id: this.state.companyId })
			.then((res) => {
				this.setState({ switchMessage: formatServerMessage(res.data.message, res.data.code == 200 ? 'Done.' : 'It could not be switched.') })
				if (res.data.code == 200) {
					this.load()
				}
			})
			.catch(() => this.setState({ switchMessage: 'It could not be switched. Please try again.' }))
	}

	toggle() {
		this.setState({
			modal: !this.state.modal
		});
	}
	alertToggle() {
		this.setState({
			alertModal: !this.state.alertModal
		});
	}
	handleChange = (checked) => {
		console.log("checked:",checked)
		this.setState({ checked });
	  }

	handleSubmit = (event) => {
		event.preventDefault();
		let id = event.target.id.value;
		let name = event.target.name.value;
		let designation = event.target.designation.value;
		let location = event.target.location.value;
		let age = event.target.age.value;
		let newObj = JSON.parse(JSON.stringify(this.state.jsonData));
		newObj[id] = [name, designation, location, age];
		this.setState({
			jsonData: newObj,
			modal: !this.state.modal
		})
	}

	// Deletes the location on the server; its row goes once the server has deleted it, a refusal is shown
	deleteLocation = () => {
		const location = this.state.obj
		this.setState({ alertModal: false })
		auth.deleteLocation({ id: location.id })
			.then((res) => {
				if (deleteSucceeded(res)) {
					this.setState({ locationData: this.state.locationData.filter((x) => x.id != location.id) })
				} else {
					window.alert(deleteFailedMessage(res, 'The location could not be deleted.'))
				}
			})
			.catch(() => window.alert(DELETE_UNREACHABLE))
	}

	render() {
		const { companyData,companyId,avatarUrl } = this.state;

		const data2 = this.state.locationData.map((prop, key) => {
			console.log("props.Country code:",prop.countrycode)
			return {
				id: key,
				name: (
					<a onClick={()=>this.props.history.push('/duty-location/'+prop.id)} style={{cursor:"pointer"}}>{prop.name}</a>
					),
				address: prop.address,
				country: getName(prop.countrycode),
				timezone: prop.timezone,
				actions: (
					// we've added some custom button actions
					<div className="text-center">
						<Switch onChange={this.handleChange} uncheckedIcon checkedIcon offColor="#ddd" checked={this.state.checked} />
					</div>
				),
				edit:(
					<div className="justify-content-around">
						<Button className="btn-table-edit" onClick={() => {
							let obj = data2.find(o => o.id === key);
							console.log(["key:",key,obj.name]);
							this.setState({
								modal: !this.state.modal,
								obj: obj,
								
							});
						}}><i className="mdi mdi-lead-pencil"  style={{color:"white"}}/></Button>
						<Button className="btn-table-remove"  onClick={() => {
							this.setState({
								alertModal: !this.state.alertModal,
								obj: prop,
							});
						}}><i className="fas fa-trash-alt" style={{color:"white"}}/></Button>
					</div>
				),
			};
		});
		  const handleOnSearch = (string, results) => {
			// onSearch will have as the first callback parameter
			// the string searched and for the second the results.
			console.log(string, results)
		  }
		
		  const handleOnSelect = (item) => {
			// the item selected
			console.log(item)
		  }
		
		  const handleOnFocus = () => {
			console.log('Focused')
		  }
		console.log("companyId::",companyId);
		return <div>
			<Modal isOpen={this.state.modal} toggle={this.toggle}>
				<ModalHeader toggle={this.toggle}>Modal title</ModalHeader>
				<ModalBody>
					<Form onSubmit={this.handleSubmit}>
						<Input type="hidden" name="id" id="id" defaultValue={this.state.obj.id} />
						<FormGroup>
							<Label for="name">Name</Label>
							<Input type="text" name="name" id="name" defaultValue={this.state.obj.name} />
						</FormGroup>
						<FormGroup>
							<Label for="designation">Designation</Label>
							<Input type="text" name="designation" id="designation" defaultValue={this.state.obj.designation} />
						</FormGroup>
						<FormGroup>
							<Label for="location">Location</Label>
							<Input type="text" name="location" id="location" defaultValue={this.state.obj.location} />
						</FormGroup>
						<FormGroup>
							<Label for="age">Age</Label>
							<Input type="text" name="age" id="age" defaultValue={this.state.obj.age} />
						</FormGroup>
						<FormGroup>
							<Button color="primary" type="submit">Save</Button>
							<Button color="secondary" className="ml-1" onClick={this.toggle}>Cancel</Button>
						</FormGroup>
					</Form>
				</ModalBody>
			</Modal>
			<Modal isOpen={!!this.state.switchModal} toggle={() => this.setState({ switchModal: false })}>
				<ModalBody className="alert-body">
					<i className="mdi mdi-alert-circle ft-60"></i>
					{this.state.switchModal === 'private' ? <React.Fragment>
						<h2>Switch this company account to a private account?</h2>
						<div>Its one client becomes the owner again (not shown as a client), with all the locations. Its guards and duties stay as they are; nothing is deleted. It then has no clients, districts, district managers or supervisors.</div>
					</React.Fragment> : <React.Fragment>
						<h2>Switch this private account to a company account?</h2>
						<div>Its owner becomes an ordinary client named after them, with all the locations. It then has clients, districts, district managers and supervisors like any company. It can be switched back while it has no other clients, districts, district managers or supervisors.</div>
					</React.Fragment>}
					<div className="height-10"></div>
					<FormGroup>
						<Button color="secondary" className="ml-1" onClick={() => this.setState({ switchModal: false })}>Cancel</Button>
						<span>&nbsp;&nbsp;</span>
						<Button color="primary" onClick={this.makeCompany}>Yes, switch it</Button>
					</FormGroup>
				</ModalBody>
			</Modal>
			<Modal isOpen={this.state.alertModal} toggle={this.alertToggle}>
				{/* <ModalHeader toggle={this.alertToggle}>Alert Modal</ModalHeader> */}
				<ModalBody className="alert-body">
					<i className="mdi mdi-alert-circle ft-60"></i>
					<h2>Delete this location?</h2>
					<div>This deletes the location for good. It is refused while the location has current or future duties; its finished duties are kept for reports.</div>
					<div className="height-10"></div>
					<FormGroup>
						<Button color="secondary" className="ml-1" onClick={this.alertToggle}>Cancel</Button>
						<span>&nbsp;&nbsp;</span>
						<Button color="primary" onClick={this.deleteLocation}>Yes, Delete It!</Button>
					</FormGroup>
				</ModalBody>
			</Modal>
			{/*--------------------------------------------------------------------------------*/}
			{/* Start Action table*/}
			{/*--------------------------------------------------------------------------------*/}
			<Card>
				
				<Row className="toolbar up-card-title">
                    <div className="b-title"><i className="mdi mdi-buffer mr-10"></i>&nbsp;{companyData[0].name}</div>
                    <div className="title-actions">
						{/* The super admin opens the company's Billing tab (invoices, mark paid, void) */}
						{localStorage.getItem('admin_level') === 'a' && <Button color="secondary" outline onClick={()=>this.props.history.push('/account?tab=billing')}>Billing</Button>}
						<Button color="primary" className="title-edit-button" onClick={()=>this.props.history.push('/company-edit')}><i className="mdi mdi-lead-pencil"></i> Edit</Button>
                    </div>
                </Row>
                <Row className="toolbar up-card-box">
                    <div style={{padding:"10px"}}><img src = {avatarUrl!=""?avatarUrl=="/storage/avatar.jpg"?avatar:baseImgURL+avatarUrl:avatar} className="img-company"></img></div>
                    <div>
 
                        <Row className="company-text-area">
                            <div className="company-text-key">Phone</div>
                            <div className="company-text-value">{formatPhone(companyData[0].phonenumber)}</div>
                        </Row>
                        <Row className="company-text-area">
                            <div className="company-text-key">Email</div>
                            <div className="company-text-value">{companyData[0].email}</div>
                        </Row>
                        <Row className="company-text-area">
                            <div className="company-text-key">Active Company</div>
                            <div className="company-text-value">{companyData[0].active==1?"TRUE":"FALSE"}</div>
                        </Row>
                        {this.state.showsTerms && (
                            <Row className="company-text-area">
                                <div className="company-text-key">Terms and Conditions</div>
                                <div className="company-text-value">{termsAcceptanceText(this.state.termsAcceptance, (iso) => new Date(iso).toLocaleString())}</div>
                            </Row>
                        )}
                        {this.state.trial && (
                            <Row className="company-text-area">
                                <div className="company-text-key">Free trial</div>
                                <div className="company-text-value">{this.state.trial.active ? 'Ends ' + this.state.trial.ends_on_label + ' (at most 2 guards)' : 'Ended ' + this.state.trial.ends_on_label}</div>
                            </Row>
                        )}
                        {/* Company or Private; the super admin may switch a Private account to a Company one */}
                        {this.state.account && localStorage.getItem('admin_level') === 'a' && (
                            <Row className="company-text-area">
                                <div className="company-text-key">Account type</div>
                                <div className="company-text-value">
                                    {accountTypeLabel(this.state.account.account_type)}
                                    {this.state.account.account_type === PRIVATE && (
                                        <span>&nbsp;<Button size="sm" color="secondary" onClick={() => this.setState({ switchModal: 'company' })}>Switch to a company account</Button></span>
                                    )}
                                    {/* Back to private: only while nothing is in the way (the server says what) */}
                                    {this.state.account.account_type !== PRIVATE && Array.isArray(this.state.account.make_private_blockers) && (
                                        <span>&nbsp;<Button size="sm" color="secondary" disabled={this.state.account.make_private_blockers.length > 0}
                                            onClick={() => this.setState({ switchModal: 'private' })}>Switch to a private account</Button>
                                            {this.state.account.make_private_blockers.length > 0 && <div className="small text-muted mt-1">
                                                To switch to a private account, first remove: {this.state.account.make_private_blockers.join(', ')}.</div>}
                                        </span>
                                    )}
                                    {this.state.switchMessage && <div className="small mt-1">{this.state.switchMessage}</div>}
                                </div>
                            </Row>
                        )}
                        {/* The super admin's Reseller choice: who earns commission on this company's invoices from now on */}
                        {this.state.reseller && localStorage.getItem('admin_level') === 'a' && (
                            <Row className="company-text-area">
                                <div className="company-text-key"><label htmlFor="company-reseller" className="mb-0">Reseller</label></div>
                                <div className="company-text-value">
                                    <Input id="company-reseller" type="select" bsSize="sm" style={{ display: 'inline-block', width: 'auto' }}
                                        value={this.state.resellerChoice} onChange={(e) => this.setState({ resellerChoice: e.target.value, resellerMessage: null })}>
                                        <option value="0">None (Mobiliis)</option>
                                        {this.state.reseller.resellers.map((option) => <option key={option.id} value={String(option.id)}>{option.name}</option>)}
                                    </Input>
                                    &nbsp;<Button size="sm" color="primary" disabled={this.state.resellerBusy} onClick={this.saveReseller}>Save</Button>
                                    {this.state.resellerMessage && <span className={'small ml-2 ' + (this.state.resellerMessage.ok ? 'text-success' : 'text-danger')}>{this.state.resellerMessage.text}</span>}
                                    <div className="small text-muted">The reseller earns commission on invoices paid from now on. Commission already earned stays with the reseller it was earned by.</div>
                                </div>
                            </Row>
                        )}
                        {/* <Row className="company-text-area">
                            <div className="company-text-key">Country</div>
                            <div className="company-text-value">{getName(companyData[0].countrycode)}</div>
                        </Row> */}
                    </div>
                </Row>
            </Card>
            {/* <Card>
				<CardBody>
					<Row className="table-header">
                        <div className="table-title"><i className="far fa-address-card"></i><span>&nbsp;Address</span></div>
                        <div style={{ width: 400 }} className="auto-complete">
                        <ReactSearchAutocomplete
                            items={items}
                            onSearch={handleOnSearch}
                            onSelect={handleOnSelect}
                            onFocus={handleOnFocus}
                            autoFocus
                        />
                        </div>
					</Row>
					<ReactTable
						columns={[
							{
								Header: "",
								id: "row",
								maxWidth: 50,
								filterable: false,
								Cell: (row) => {
									return <div>{row.index+1}</div>;
								}
							},
							{
								Header: "Location",
								accessor: "name"
							},
							{
								Header: "Address",
								accessor: "address"
							},
							{
								Header: "Country",
								accessor: "country"
							},
							{
								Header: "Timezone",
								accessor: "timezone"
							},
							// {
							// 	Header: "ACTIVE",
							// 	accessor: "actions",
							// 	sortable: false,
							// 	filterable: false
							// },
							// {
							// 	Header: "",
							// 	accessor:"edit",
							// 	id: "row",
							// 	maxWidth: 100,
							// 	filterable: false,
							// },							
						]}
						defaultPageSize={10}
						showPaginationBottom={true}
						className="-striped -highlight"
						data={data2}
						// filterable
					/>
					
				</CardBody>
			</Card> */}
			{/*--------------------------------------------------------------------------------*/}
			{/* End Action table*/}
			{/*--------------------------------------------------------------------------------*/}
		</div>
	}
}

export default CompanyView;
